import React from "react";
import './styles.css'

const ButtonRow = ({ children, isVertical = false }) => {
    return (
        <div className={`${isVertical === true ? 'button-row-vertical' : 'button-row'} `}>{children}</div>
    )
}

export default ButtonRow